import { BlobArray } from "@pdfking/blob"
import type { BlobArrayType } from "@pdfking/blob"
import type { StreamInput } from "@pdfking/io"
import { StreamProcess } from "@pdfking/io"
import { Collect } from "@pdfking/tfunc"

/** Drains whatever a caller has into the blob it adds up to.
 *
 * The other end of `UInt8Collect`, for callers holding a file rather than
 * reading one: a preview URL, an upload, an image decoder.
 *
 * A BlobArray rather than a merge, and every part kept as it came: bytes stay
 * bytes and a blob stays a blob, so a file-backed one is still a file when
 * this returns and nothing was read to put it here. What comes back answers
 * for the whole of it as if it were one blob.
 *
 * @example
 * ```ts
 * import { BlobCollect } from "@pdfking/io"
 *
 * const blob = await BlobCollect(response.body, "application/pdf")
 * ```
 */
export const BlobCollect = (value: StreamInput, type?: string): Promise<BlobArrayType> =>
  Collect(StreamProcess(value)).then(parts => BlobArray(parts, type))
